// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/5408c958/" + chunkId + "." + __webpack_require__.h() + ".v5408c958.js";
};